import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, User, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Blog() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/blogs").then((r) => setItems(r.data));
  }, []);

  return (
    <>
      <SEO title="News & Insights" description="Articles on veterinary nutrition, pharmaceutical manufacturing and field performance from Forage Animal Health & Nutrition." path="/blog" />

      <section className="bg-[#0B2545] text-white py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden">
        <div className="absolute inset-0 grid-pattern opacity-20" />
        <div className="container-fr relative">
          <span className="overline text-[#2A9D8F]">News & Insights</span>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-black mt-3 leading-tight max-w-3xl">
            Veterinary science, manufacturing best practices, field data.
          </h1>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-fr grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {items.length === 0 && <p className="text-slate-600 col-span-full">New articles will be published here. For technical literature, visit our product catalogues.</p>}
          {items.map((b, i) => (
            <Link
              to={`/blog/${b.slug}`}
              key={b.id}
              data-testid={`blog-card-${b.slug}`}
              className="group bg-white rounded-xl border border-slate-200 overflow-hidden card-lift fade-up"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="h-56 overflow-hidden bg-slate-100">
                <img src={b.image_url} alt={b.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-slate-500">
                  <span className="inline-flex items-center gap-1.5"><User size={12} />{b.author}</span>
                  <span className="inline-flex items-center gap-1.5"><Calendar size={12} />{new Date(b.created_at).toLocaleDateString()}</span>
                </div>
                <h3 className="font-display text-xl font-bold text-[#0B2545] mt-3 leading-snug">{b.title}</h3>
                <p className="text-sm text-slate-600 mt-3 line-clamp-3">{b.excerpt}</p>
                <span className="inline-flex items-center gap-1 text-[#2A9D8F] text-sm font-medium mt-5 group-hover:gap-2 transition-all">
                  Read article <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
